/** @format */

import React from "react";
import { AllParams } from "../ResourcesFilter";
import { QueryProps } from "../../resourceIndexUI/ResourcesIndexUI";
import { useTranslation } from "react-i18next";
import { ReactComponent as Circle } from "bootstrap-icons/icons/circle.svg";
import { ReactComponent as CheckCircle } from "bootstrap-icons/icons/check-circle-fill.svg";
import { qualIdToFull } from "../../../../utils/functions";
import { filterResources } from "../utils";
import { ResourceReference } from "../../../../types";

type Props = {
  isLoading?: boolean;
  query: QueryProps;
  allParams: AllParams;
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
  resources: ResourceReference[] | undefined;
};

const QualificationFilter: React.FC<Props> = ({
  isLoading,
  allParams,
  query,
  handleQueryItemClick,
  resources,
}) => {
  const { t: _ } = useTranslation();
  let allQuals = resources
    ? [...allParams.qualification].map((t) => {
        const count = filterResources(
          [...resources],
          "qualification",
          query,
        ).filter((r) => r.Qualification === t.title).length;
        if (count !== t.count) {
          return { ...t, count: count };
        }
        return t;
      })
    : [...allParams.qualification];

  return (
    <>
      {(!!allQuals?.length || isLoading) && (
        <div className="card shadow mb-3">
          <div className="card-body" key="level-filter">
            <h5>{_("Qualification")}</h5>
            {isLoading &&
              [1, 2, 3].map((i) => (
                <button
                  key={`level${i}`}
                  className={`w-100 btn btn-light text-start py-0 mb-2`}
                >
                  <Circle />
                  &emsp;<span className="placeholder col-4"></span>{" "}
                  <span className="float-end placeholder col-1"></span>
                </button>
              ))}

            {allQuals
              ?.sort((a, b) => (a.title < b.title ? -1 : 1))
              .map((_qual) => (
                <button
                  key={_qual.title}
                  onClick={() =>
                    handleQueryItemClick(_qual.title, "qualification")
                  }
                  className={`w-100 btn btn-light text-start py-0 mb-2 d-flex align-items-start`}
                  data-testid="qual-filter-btn"
                >
                  <div className="flex-grow-1 d-flex align-items-start gap-2 gap-lg-4">
                    <div className="flex-shrink-0">
                      {_qual.title === query.qualification ? (
                        <CheckCircle />
                      ) : (
                        <Circle />
                      )}
                    </div>
                    {_(qualIdToFull(_qual.title))}{" "}
                    {_qual.title.startsWith("mfw") && (
                      <span className="badge text-end bg-primary mt-1">
                        {_("new")}
                      </span>
                    )}
                  </div>
                  <div className="float-end text-end ms-2">
                    <span className="text-muted">{_qual.count}</span>
                  </div>
                </button>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default QualificationFilter;
